import React from "react";
import SkeletonCard from "./SkeletonCard";

const SkeletonPayoutCard = ({ iconBgColor = "bg-green-400/10" }) => {
  return (
    <div className="bg-white/5 border border-white/10 rounded-xl p-6 backdrop-blur-xl">
      <div className="flex items-center justify-between">
        <div>
          <SkeletonCard width="w-32" height="h-4" className="mb-2" />
          <SkeletonCard width="w-24" height="h-8" />
        </div>
        <div className={`p-3 ${iconBgColor} rounded-full`}>
          <SkeletonCard width="w-6" height="h-6" rounded="rounded" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonPayoutCard; 